import type { CategorizationRule } from './types';

export const P2P_RULES: CategorizationRule[] = [
  {
    category: "P2P Payment",
    types: ["QUICKPAY_DEBIT", "CHASE_TO_PARTNERFI"],
    keywords: [],
  },
  {
    category: "P2P Payment",
    types: ["ACH_DEBIT"],
    keywords: ["venmo", "paypal"],
  },
  {
    category: "P2P Payment",
    keywords: ["zelle payment to"],
  },
];
